module.exports = __webpack_public_path__ + "images/embed/play-video-link.png";